import { Fc2Spinner } from "./Fc2Spinner";

/** Covers a browse panel while hub/project/folder lists reload. */
export function BrowseBusyOverlay({
  message = "Updating…",
  variant = "dark",
}: {
  message?: string;
  variant?: "dark" | "light";
}) {
  const light = variant === "light";
  return (
    <div
      aria-busy="true"
      aria-live="polite"
      style={{
        position: "absolute",
        inset: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 10,
        background: light
          ? "rgba(255, 255, 255, 0.88)"
          : "rgba(20, 20, 20, 0.72)",
        borderRadius: 6,
        zIndex: 2,
      }}
    >
      <Fc2Spinner size={32} label={message} />
      <span
        style={{
          fontSize: 11,
          color: light ? "#6b7280" : "var(--fc2-text-dim)",
        }}
      >
        {message}
      </span>
    </div>
  );
}
